var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"min-width",attrs:{"small":""},on:{"click":_vm.onClick}},[_vm._v("共有")])
}
var staticRenderFns = []

export { render, staticRenderFns }